import {
  createQueryAtomFactory,
  QueryAtomResult,
} from '~/shared/providers/api/createQueryAtomFactory';

export type ComplianceHoldRecord = QueryAtomResult<
  typeof complianceHoldsQueryAtom
>[number];

export const complianceHoldsQueryAtom = createQueryAtomFactory(
  'trade.complianceHolds',
  (params: { purchaseLoadId: string }) => ({
    complianceHolds: {
      __args: {
        filter: { purchaseLoadId: params.purchaseLoadId },
        sorting: ['HoldStartDesc' as const],
        pagination: { offset: 0, limit: 50 },
      },
      entries: {
        id: true,
        purchaseLoadId: true,
        accountId: true,
        status: true,
        holdStart: true,
        holdEnd: true,
        holdDays: true,
        maxImmediateCash: true,
        exemptionReason: true,
        releasedAt: true,
        releasedByUserId: true,
        jurisdictionCode: true,
        notes: true,
        timestamps: {
          createdAt: true,
          updatedAt: true,
        },
      },
    },
  }),
  {
    select: (data) => {
      if (!data) return [];
      return (data.complianceHolds?.entries ?? []).map((entry) => ({
        id: entry.id,
        purchaseLoadId: entry.purchaseLoadId,
        accountId: entry.accountId,
        status: entry.status,
        holdStart: entry.holdStart,
        holdEnd: entry.holdEnd,
        holdDays: entry.holdDays,
        maxImmediateCash: entry.maxImmediateCash ?? null,
        exemptionReason: entry.exemptionReason,
        releasedAt: entry.releasedAt ?? null,
        releasedByUserId: entry.releasedByUserId ?? null,
        jurisdictionCode: entry.jurisdictionCode ?? null,
        notes: entry.notes ?? null,
        createdAt: entry.timestamps.createdAt,
        updatedAt: entry.timestamps.updatedAt,
      }));
    },
  },
);
